import React, { Fragment, useEffect, useState, useRef } from 'react';
import BannerData from '../model/top/bannerData';
import NewsData, { getNewsCategoryName, getDataCategory } from '../model/top/newsData';
import RoadMapData from '../model/top/roadmapData';
import CharacterBannerData from '../model/top/characterBannerData';
import { TopBannerSlider, TopPopupSlider } from './component/bannerSlider';
import { GetPanelPositionRem, AdjustLineXPos, SetArrowHeight } from './component/roadmapLayout';
import SwiperCore from "swiper";

interface ViewProps {
    bannerData: BannerData[];
    charBannerData: CharacterBannerData;
    newsData: NewsData[];
    roadmapData: RoadMapData[];
    isSuccess: boolean;
}

const View:React.FC<ViewProps> = (props: ViewProps) => {
    
    let arrowHeight = 0;

    // ポップアップウインドウの画像
    // 順番：①②号外1（渋谷）③④⑤号外（2万人）⑥
    let popupImageArray = ["zircon_ep1.jpg","zircon_ep2.jpg","zircon_extra.jpg","zircon_ep3.jpg","zircon_ep4.jpg","zircon_ep5.jpg","zircon_extra2.jpg","zircon_ep6.jpg"];
    const [activeIndex, setActiveIndex] = useState(0);
    const swiperRef = useRef<SwiperCore | null>(null);
    const prevRef = useRef<HTMLDivElement>(null);
    const nextRef = useRef<HTMLDivElement>(null);

    const [allowPrev, setAllowPrev] = useState(true);
    const [allowNext, setAllowNext] = useState(true);

      
    // ポップアップウインドウのSwiperの矢印を表示非表示切り替えるために再初期化
    useEffect(() => {
        if (
            swiperRef.current &&
            prevRef.current&&
            nextRef.current&&
            swiperRef.current.params.navigation &&
            typeof swiperRef.current.params.navigation !== "boolean"
        ) {
            // 再初期化
            swiperRef.current.params.navigation.prevEl = prevRef.current;
            swiperRef.current.params.navigation.nextEl = nextRef.current;
            swiperRef.current.navigation.destroy();
            swiperRef.current.navigation.init();
            swiperRef.current.navigation.update();
        }
    }, [activeIndex]);
  

    // ポップアップ表示中フラグ
    const [isOpenPopup, setIsOpenPopup] = useState(false);

    useEffect(() => {
        const scriptUrl = document.createElement('script');
        scriptUrl.type = 'text/javascript';
        scriptUrl.src = '../assets/js/common.min.js';
        document.body.appendChild(scriptUrl);

        const scriptUrl2 = document.createElement('script');
        scriptUrl2.type = 'text/javascript';
        scriptUrl2.src = '../assets/js/top.min.js';
        document.body.appendChild(scriptUrl2);
    }, []);

    const buttonRef = useRef<HTMLButtonElement>(null);
    useEffect(() => {
        console.log("hoge1");
        const timer = setTimeout(() => {
            console.log("hoge2");
        if (buttonRef.current) {
            console.log("hoge3");
            buttonRef.current.classList.add('fade-out');
        }
        }, 30000); // 30秒後にフェードアウト

        return () => clearTimeout(timer);        
    }, []);

    useEffect(() => {
        // レイアウト配置
        ChangeLayout();

        // ウィンドウサイズが変更された時レイアウトと画像が変わるので再計算する
        matchMedia('(max-width: 768px)').addEventListener("change", ChangeLayout); 

        // scrollTriggerの開始位置がうまく設定できていなかったので、
        // パネル表示完了まで少し待機させる
        const roadmapSet = setTimeout(() => {
            const scriptUrl3 = document.createElement('script');
            scriptUrl3.type = 'text/javascript';
            scriptUrl3.src = '../assets/js/top-roadmap.min.js';
            document.body.appendChild(scriptUrl3);
        }, 1200);

        return () => {
            matchMedia('(max-width: 768px)').removeEventListener("change", ChangeLayout);
            clearTimeout(roadmapSet);
        }
    },[props.isSuccess]);

    const mediaCheck = window.matchMedia('(max-width: 768px)');
    let imageTopMaskThreshold = 17;

    // レイアウトの配置位置を計算
    function ChangeLayout()
    {
        // パネルの配置位置計算
        let roadmapPos_rem = 0;
        let year = 0;

        for (let i = 0; i < props.roadmapData.length - 1; i++)
        {
            year = 2024 + i;
            let roadmap = document.getElementById("roadmap_" + (year));
            let roadmap_before = document.getElementById("roadmap_" + (year - 1));
            let roadmap_check = document.getElementById("roadmap_" + (year - 2));

            let line = document.getElementById("line_x" + (year));

            if (roadmap_before == null)
            {
                continue;
            }

            let checkHeight = 0;
            if (roadmap_check != null)
            {
                checkHeight = roadmap_check?.clientHeight + parseFloat(window.getComputedStyle(roadmap_check).top);
            }
                
            let topHeight = parseFloat(window.getComputedStyle(roadmap_before).top);

            roadmapPos_rem = GetPanelPositionRem(roadmap_before.clientHeight, topHeight, checkHeight);
            line?.style.setProperty("top", AdjustLineXPos(roadmapPos_rem) + "rem");
            roadmap?.style.setProperty("top", roadmapPos_rem + "rem");
        }

        // 縦矢印の情報取得
        let arrow = document.getElementById("arrow");
        let roadmap = document.getElementById("roadmap_" + (year));
        if (roadmap == null)
        {
            return;
        }
        // 基準となるフォントサイズの取得
        const root = document.documentElement;
        let style = window.getComputedStyle(root).getPropertyValue('font-size');
        let rootFontSize = parseFloat(style);
        let roadmapRem = roadmapPos_rem + (roadmap.clientHeight / rootFontSize);
            
        // 縦矢印の長さをセット
        arrow?.style.setProperty("height", SetArrowHeight(roadmapRem) + "rem");

        //ロードマップエリアにも矢印と同じ値をセット
        let roadmap_area = document.getElementById("roadmap_area");
        roadmap_area?.style.setProperty("height", SetArrowHeight(roadmapRem) + "rem");

        // 横線の左右の向き設定
        let lines = document.querySelectorAll('.line_auto');
        lines.forEach((line) => {
            
            let line_year = line.id.slice(-4);
            if (parseInt(line_year) % 2 == 1)
            {
                if (mediaCheck.matches)
                {
                    line.classList.add('left');
                }
                else
                {
                    line.classList.remove('left');
                }
            }
        })
    }
        
    return (
        <>
            <title>PROJECT ZIRCON（プロジェクト ジルコン） 公式サイト</title>
            <div id="opening">
                <p className="opnening_logo"><img src="./assets/img/logo.png" alt="PROJECT ZIRCON（プロジェクト ジルコン）" width="258" height="96" /></p>
                <p className="opnening_txt"><img src="./assets/img/top/opening_txt.png" alt="冒険と創造の毎日を。" width="1132" height="123" /></p>
                <p className="opnening_txt_sp1"><img src="./assets/img/top/catch_main_top_sp.png" alt="冒険と創造の" /></p>
                <p className="opnening_txt_sp2"><img src="./assets/img/top/catch_main_top_sp2.png" alt="毎日を。" /></p>
            </div>
            <header id="konami_hd">
                <div className="inner">
                    <h1 className="konami_logo"><a href="https://www.konami.com/games/jp/ja/" rel="noopener noreferrer" target="_blank"><img src="./assets/img/hd_logo_konami.svg" alt="KONAMI" /></a></h1>
                </div>
            </header>

            {/*左下固定のポップアップ呼び出しボタン*/}
            <button id = "id-popup-start-button" className="popup-start-button" type="button" onClick={() => setIsOpenPopup(true)} ref={buttonRef}>
                <img src="./assets/img/top/popup_icon.png" alt="ポップアップボタン" />
            </button>

            {/*ポップアップ*/}
            <div>
                {isOpenPopup && (
                    <div className="popup-overlay">
                        <div className="popup-window">
                            <button className="popup-close-button" onClick={() => setIsOpenPopup (false)}>×</button>
                            <div className="popup-content">
                            <img src="./assets/img/top/popup_backgroud.png" alt="背景" className="popup-background-image" />

                            <div className="slide_wrap" >
                                {<>{TopPopupSlider(popupImageArray, setActiveIndex, swiperRef,allowPrev, setAllowNext,allowPrev, setAllowNext)}</>}
                                {   // 最後の画像の時は右矢印非表示
                                    activeIndex < popupImageArray.length - 1 && (<div ref={nextRef} className="swiper-button-next swiper-button-next-popup"></div>)
                                }
                                {   // 1枚目の画像の時は左矢印非表示
                                    activeIndex > 0 && (<div ref={prevRef} className="swiper-button-prev swiper-button-prev-popup"></div>)
                                }
                                <div className="swiper-pagination swiper-pagination-popup"></div> 
                                <link rel="stylesheet" href="./assets/css/top.min.css" />
                            </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>

            <div id="mainContent" className="wrapper">
                <div className="gem_wrap back">
                    <div className="gem" id="gem_back"></div>
                </div>
                <div className="gem_wrap front">
                    <div className="gem" id="gem_front"></div>
                </div>
                <header id="incHd"></header>
                <main>
                    <section className="hero_area">
                        <picture>
                            <div className="draw-sp">
                                <p className="main_catch"><img src="./assets/img/top/catch_main_top_sp.png" alt="冒険と創造の" /></p>
                                <img src="./assets/img/top/top_kv_sp.jpg" alt="キービジュアル" style={{marginTop: '50px', marginBottom: '50px'}} />
                                <p className="main_catch_sp"><img src="./assets/img/top/catch_main_top_sp2.png" alt="毎日を。" /></p>
                            </div>
                            <div className="draw-pc">
                                <img src="../assets/img/top/top_kv_pc.jpg" alt="キービジュアル" />
                            </div>
                        </picture>
                    </section>
                    <section className="banner_area">
                        <p className="btn_about"><a href="./about/"><img src="./assets/img/top/btn_about.png" alt="PROJECT ZIRCONとは？" width="719" height="134" /></a></p>
                        <div className="slide_wrap">
                            {<>{TopBannerSlider(props.bannerData)}</>}
                            <div className="swiper-button-next swiper-button-next-banner"></div>
                            <div className="swiper-button-prev swiper-button-prev-banner"></div>
                            <div className="swiper-pagination swiper-pagination-banner"></div> 

                            <link rel="stylesheet" href="./assets/css/top.min.css" />
                        </div>
                    </section>
                    <section className="movie_area">
                        <div className="inner">
                            <p className="catch blur">
                                <picture>
                                    <source srcSet="./assets/img/top/mov_catch.svg" media="(min-width: 769px)" />
                                    <img src="./assets/img/top/mov_catch_sp.svg" alt="新作ゲームをみんなで創る" width="625" height="238" />
                                </picture>
                            </p>
                            <div className="mov_wrap blur">
                                <button className="mov modal_yt_thumb01" type="button"><img src="./assets/img/top/mov_thumbnail.png" alt="PROJECT ZIRCON（プロジェクト ジルコン）PV" /></button>
                            </div>
                            <p className="lead blur">「PROJECT ZIRCON」は<br/>KONAMIが主導する共創プロジェクトです。<br />ゴールは<em>みんなでゲームを完成させる事!</em><br/>その過程からみなさんが関わっていく事ができます。<br/><a href="./guideline" rel="noopener noreferrer" target="_blank">ルールを守ればIPの商用利用もOK!</a><br />誰でもコンテンツの創作に<br className="sp-br" />自由に参加することができます。</p>
                            
                            <h4 className="report_ttl fadeup">最新情報は公式Xをフォロー！</h4>
                            <div className="btn_hexagon btn_about fadeup">
                                <a href="https://x.com/Project_Zircon" rel="noopener noreferrer" target="_blank" className="btn_link">公式Xへ</a>
                            </div>
                        </div>
                        <div className="modal_yt01 modal_yt modal_area">
                            <div className="modal_overlay"></div>
                            <div className="modal_inner">
                                <button className="modal_cross" type="button"></button>
                                <div id="modal_btn_yt01"></div>
                            </div>
                        </div>
                    </section>
                    <section className="information_area">
                        <div className="inner">
                            <h2 className="sec_ttl blur">
                                <span className="en">INFORMATION</span>
                                <span className="jp">お知らせ</span>
                            </h2>
                            <div className="flx_box">
                                <div className="news_wrap fadeleft">
                                    <h3 className="elm_ttl">《 NEWS 》</h3>
                                    <ul className="tab">
                                        <li className="active" data-filter="all">ALL</li>
                                        <li data-filter="product">コンテンツ</li>
                                        {/*
                                            WEB3タブはいったん非表示
                                            <li data-filter="web3">WEB3</li>
                                        */}
                                        <li data-filter="ugc">クリエイター</li>
                                    </ul>
                                    <div className="news_list_wrap">
                                        <ul className="news_list">
                                            {
                                                props.newsData.map((content, index) => {
                                                    return <li key={index} className='news_item active' data-category={getDataCategory(content.type)}>
                                                        {content.url == null || content.url == "" ? null : <a href={content.url} target='_blank' className='overlay_link'></a>}
                                                        <p className='cate'>{getNewsCategoryName(content.type)}</p>
                                                        <p className='date'>{content.releaseDate}</p>
                                                        <p className='txt'>{content.text}</p>
                                                    </li>
                                                })
                                            }
                                        </ul>
                                    </div>
                                </div>
                                <div className="x_wrap faderight">
                                    <h3 className="elm_ttl">《 公式X 》</h3>
                                    <div className="x_timeline"><a className="twitter-timeline" data-chrome="noheader noscrollbar noborders" href="https://twitter.com/Project_Zircon?ref_src=twsrc%5Etfw">Tweets by Project_Zircon</a>
                                        <script async src="https://platform.twitter.com/widgets.js" charSet="utf-8"></script>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="chara1 fadeleft">
                            <picture>
                                <source srcSet="./assets/img/top/bg_chara_pope_top.png" media="(min-width: 769px)" />
                                <img src="./assets/img/top/bg_chara_pope_top_sp.png" alt="教皇" width="622" height="1118" />
                            </picture>
                        </div>
                        <div className="chara2 faderight">
                            <picture>
                                <source srcSet="./assets/img/top/bg_chara_queen_top.png" media="(min-width: 769px)" />
                                <img src="./assets/img/top/bg_chara_queen_top_sp.png" alt="女王" width="642" height="1282" />
                            </picture>
                        </div>
                        <p className="bg_txt fadeleft"><img src="./assets/img/top/bg_txt_news_top.png" alt="News" width="750" height="221" /></p>
                        <div className="compass_wrap">
                            <p className="bg_compass"><img src="./assets/img/bg_compass_anime.svg" alt="" width="6058" height="6058" /></p>
                        </div>
                    </section>
                    <section className="character_area">
                        <h2 className="sec_ttl blur">
                            <span className="en">CHARACTER</span>
                            <span className="jp">キャラクター</span>
                        </h2>
                        <div className="loop_wrap">
                            <ul className="loop right">
                                {
                                    props.charBannerData.mstCharacterIdsUpper.map((content, index) => {
                                        return <li key={index}><a href={`./nft/character/${content.mstCharacterId}`}><img src={`${process.env.REACT_APP_CHARA_IMAGE_URL}${content.imageFile}`} alt="" width="250" height="250" /></a></li>
                                    })
                                }
                                {
                                    props.charBannerData.mstCharacterIdsUpper.map((content, index) => {
                                        return <li key={index}><a href={`./nft/character/${content.mstCharacterId}`}><img src={`${process.env.REACT_APP_CHARA_IMAGE_URL}${content.imageFile}`} alt="" width="250" height="250" /></a></li>
                                    })
                                }
                            </ul>
                        </div>
                        <div className="loop_wrap">
                            <ul className="loop left">
                                {
                                    props.charBannerData.mstCharacterIdsLower.map((content, index) => {
                                        return <li key={index}><a href={`./nft/character/${content.mstCharacterId}`}><img src={`${process.env.REACT_APP_CHARA_IMAGE_URL}${content.imageFile}`} alt="" width="250" height="250" /></a></li>
                                    })
                                }
                                {
                                    props.charBannerData.mstCharacterIdsLower.map((content, index) => {
                                        return <li key={index}><a href={`./nft/character/${content.mstCharacterId}`}><img src={`${process.env.REACT_APP_CHARA_IMAGE_URL}${content.imageFile}`} alt="" width="250" height="250" /></a></li>
                                    })
                                }
                            </ul>
                        </div>
                        <p className="bg_txt faderight"><img src="./assets/img/top/bg_txt_characters_top.png" alt="Characters" width="1368" height="231" /></p>
                    </section>
                    <section className="roadmap_area">
                        <div className="inner">
                            <h2 className="sec_ttl blur">
                                <span className="en">ROAD MAP</span>
                                <span className="jp">ロードマップ</span>
                            </h2>
                            <div className="roadmap_wrap" id='roadmap_area' {...arrowHeight == 0 ? null : {style: {height: `${ arrowHeight }rem`}}}>
                                <div className="line_wrap">
                                    <div className="arrow" id='arrow' {...arrowHeight == 0 ? null : {style: {height: `${ arrowHeight }rem`}}}>
                                        <div className="line_y"></div>
                                    </div>
                                    {/* 横線の表示 */}
                                    {
                                        props.roadmapData.map((contents, index) => {
                                            return <Fragment key={index}>
                                                <div className={`line line_auto ${parseInt(contents.year) % 2 == 0 || mediaCheck.matches ? 'left' : ''}`} id={`line_x${contents.year}`}>
                                                    <div className="line_x"></div>
                                                </div>
                                            </Fragment>
                                        })
                                    }
                                </div>
                                {/* ロードマップ表示 */}
                                {
                                    props.roadmapData.map((contents, index) => {
                                        return <Fragment key={index}>
                                            <div className={`panel roadmap_auto ${parseInt(contents.year) % 2 == 0 ? 'right' : ''}`} id={`roadmap_${contents.year}`}>
                                                <p className='year'>{contents.year}</p>
                                                {
                                                    contents.roadMapSeasons.map((seasons, index) => {
                                                        return <Fragment key={index}>
                                                            {/* 背景色のチェック */}
                                                            <div className='completed' style={{backgroundColor: seasons.roadMapItems.some(item => item.isClear == false) ? '#ffffff00' : '#f6e5d5ef'}}>
                                                                <p className={`season${seasons.seasonFontSize == 1 ? '_large' : ''}`}>{seasons.season}</p>
                                                                {/* 小項目の表示 */}
                                                                {
                                                                    seasons.roadMapItems.map((items, index) => {
                                                                        return <Fragment key={index}>
                                                                            <p className={`${items.isCancelLine ? 'cancel_line' : ''} ${items.isClear ? 'clear_' : '' }item${items.itemFontSize == 1 ? '_large' : ''}`}>{items.itemText}</p>
                                                                        </Fragment>
                                                                    })
                                                                }
                                                                {/* COMPLETED画像の表示 */}
                                                                {/* 小項目の数、テキストの大きさ、1行の文字数で適用するclassを変更する */}
                                                                {
                                                                    seasons.roadMapItems.some(item => item.isClear == false) ? null : 
                                                                    <img src='./assets/img/top/completed.png' className={`${
                                                                        seasons.roadMapItems.length != 1 
                                                                        ? 'img_mask_normal' 
                                                                        : seasons.seasonFontSize != 0 || seasons.roadMapItems[0].itemFontSize != 0
                                                                        ? 'img_mask_normal'
                                                                        : seasons.roadMapItems[0].itemText.length <= imageTopMaskThreshold
                                                                        ? 'img_mask_top'
                                                                        : 'img_mask_top_phone'
                                                                    }`} /> 
                                                                }
                                                            </div>
                                                            {/* 点線の表示 */}
                                                            {
                                                                contents.roadMapSeasons.length - 1 == index ? null : <p className='dotted_line'></p>
                                                            }
                                                        </Fragment>
                                                    })
                                                }
                                            </div>
                                        </Fragment>
                                    })
                                }
                            </div>
                        </div>
                        <div className="chara fadeleft">
                            <picture>
                                <source srcSet="./assets/img/top/bg_chara_commissioner_top.png" media="(min-width: 769px)" />
                                <img src="./assets/img/top/bg_chara_commissioner_top_sp.png" alt="" width="896" height="1234" />
                            </picture>
                        </div>
                        <p className="bg_txt faderight"><img src="./assets/img/top/bg_txt_roadmap_top.png" alt="Road Map" width="1339" height="222"/></p>
                        <div className="compass_wrap">
                            <p className="bg_compass"><img src="./assets/img/bg_compass_anime.svg" alt="" width="6058" height="6058" /></p>
                        </div>
                    </section>
                    <section className="contact_area">
                        <div className="inner">
                            <h2 className="sec_ttl blur">
                                <span className="en">CONTACT</span>
                                <span className="jp">お問い合わせ</span>
                            </h2>
                            <p className="txt blur">ゲームに関するご意見や<br className="sp-br" />各種お問い合わせはこちら</p>
                            <div className="btn_hexagon btn_about fadeup">
                                <a href="https://www.konami.com/games/inquiry/jp/" rel="noopener noreferrer" target="_blank" className="btn_link">お問い合わせへ進む</a>
                            </div>
                        </div>
                        <div className="chara faderight">
                            <picture>
                                <source srcSet="./assets/img/top/bg_chara_chancellor_top.png" media="(min-width: 769px)" />
                                <img src="./assets/img/top/bg_chara_chancellor_top_sp.png" alt="" width="472" height="1658" />
                            </picture>
                        </div>
                        <p className="bg_txt fadeleft"><img src="./assets/img/top/bg_txt_contact_top.png" alt="Contact" width="906" height="229" /></p>
                    </section>
                </main>
                <footer id="incFt"></footer>
            </div>
    </>
    );
};

export default View;